import AppFrame from "./AppFrame";

export default AppFrame;
